import {
  PAYROLL_CALCULATION_METHOD,
  PayrollCalculationMethod
} from '../models/deal-payroll.model';

export const DEAL_BATCH_REQUEST_COUNT = 1;
export const NO_BATCH_REQUESTS = 0;
export const INDEX_NOT_FOUND = -1;
export const DEAL_PAYROLL_GROUP_EMPTY_LENGTH = 0;
export const DEAL_PAYROLL_GROUP_STRING_TYPE = 'string';
export const DEAL_PAYROLL_GROUP_OBJECT_TYPE = 'object';
export const VALID_PAYROLL_CALCULATION_METHODS: PayrollCalculationMethod[] = [
  PAYROLL_CALCULATION_METHOD.INTERNAL,
  PAYROLL_CALCULATION_METHOD.PLANFIX_HOURLY,
  PAYROLL_CALCULATION_METHOD.PLANFIX_DEAL
];



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/deal-payroll-group-report.constants.ts